import { Component, Input, OnInit } from '@angular/core';
import { ServicioService } from 'app/services/servicio.services';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { obtenerCertificado } from 'app/models/ejemplo.model';
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {

  //@Input() public Data: any ;
  public Data: any = [];
  public year: any;
  constructor(private _servicios: ServicioService, private _router: Router) { }

  ngOnInit() {
    if (sessionStorage.getItem("token") == null) {
      this._router.navigateByUrl("login");
    }
    console.log(sessionStorage.getItem("CodObra"));
    var cliente: obtenerCertificado = new obtenerCertificado();

    cliente.obra = sessionStorage.getItem("CodObra");
    cliente.cliente = sessionStorage.getItem("cliente");
    cliente.numeroMuestra = sessionStorage.getItem("numeroMuestra");
    cliente.certificado = sessionStorage.getItem("certificado");

    this._servicios.obtenercertificado(cliente).subscribe(
      result => {
        console.log(result);
        this.Data = result;
        var strDate = new Date(); // By default Date empty constructor give you Date.now
        var shortYear = strDate.getFullYear();
        this.year = shortYear.toString().substr(-2);

      }, error => {

        this._router.navigateByUrl("login");
      });;
    console.log(this.Data);
  }

}



// WEBPACK FOOTER //
// ./src/app/popup/popup.component.ts